// extracted by mini-css-extract-plugin
export default {"archiveButton":"ArchiveAction_archiveButton__wud9X"};